'use client'

import Link from 'next/link'
import { Section, SectionHeading } from '@/components/platform/v2/Section'
import CaseCard from './CaseCard'
import { CASES } from '@/data/cases'

const HomeCases = () => {
    const [flagship, m1, m2, s1, s2] = CASES

    return (
        <Section tone="quiet" id="cases">
            <SectionHeading
                eyebrow="Реальные сценарии"
                title={
                    <>
                        Не просто функции.
                        <br />
                        Вот как VCENTRE.ONE работает в бизнесе.
                    </>
                }
                text="Мы собираем VCENTRE.ONE вокруг процесса конкретной компании: от первого контакта с клиентом до CRM, продаж, сервиса и повторного взаимодействия."
            />

            <div className="mt-12 grid gap-5">
                <CaseCard item={flagship} size="flagship" />
                <div className="grid gap-5 lg:grid-cols-2">
                    <CaseCard item={m1} />
                    <CaseCard item={m2} />
                </div>
                <div className="grid gap-5 sm:grid-cols-2">
                    <CaseCard item={s1} size="small" />
                    <CaseCard item={s2} size="small" />
                </div>
            </div>

            <div className="mt-10 flex justify-center">
                <Link href="/platform/cases" className="btn-primary">
                    Все кейсы
                </Link>
            </div>
        </Section>
    )
}

export default HomeCases
